// src/stone/illustrations/StonjiWhiteHeartIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var StonjiWhiteHeartIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 152 152",
    width: "1em",
    height: "1em",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { fill: "#00A868", d: "M0 0h152v152H0z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M47.419 80.628c15.743 0 28.506-12.763 28.506-28.505 0-15.743-12.763-28.506-28.506-28.506S18.914 36.38 18.914 52.123 31.676 80.628 47.42 80.628M104.572 80.628c15.743 0 28.506-12.763 28.506-28.505 0-15.743-12.763-28.506-28.506-28.506S76.067 36.38 76.067 52.123s12.762 28.505 28.505 28.505M75.916 128.383a4.754 4.754 0 1 0 0-9.507 4.754 4.754 0 0 0 0 9.507"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M72.044 126.384 23.936 68.265l7.735-5.526 48.108 58.127z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "m79.788 126.384 48.107-58.119-7.726-5.526-48.108 58.127z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M69.936 51.963h18.276l26.724 14.404-3.519 18.124-35.341 39.239-40.6-51.426z"
        }
      )
    ]
  }
);
var StonjiWhiteHeartIllustration_default = StonjiWhiteHeartIllustration;

export {
  StonjiWhiteHeartIllustration,
  StonjiWhiteHeartIllustration_default
};
